import { IconStarRegular, IconStarSolid, Text } from '@croquiscom-pvt/zds';
import { Vars } from '@croquiscom-pvt/zds/dist/tokens';
import { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';

import { numberInTenThousandWithFloor } from '@common/utils';

interface Props {
  icon_color?: keyof Vars['color'];
  saved_icon_color?: keyof Vars['color'];
  count_color?: keyof Vars['color'];
  onClick?: () => void;
  bookmark_count: number;
  is_saved_shop?: boolean;
  gap?: number;
}

export const Bookmark = ({
  icon_color = 'iconPrimary',
  saved_icon_color = 'accentPinkPrimary',
  count_color = 'textTertiary',
  onClick,
  bookmark_count,
  is_saved_shop,
  gap = 0,
}: Props) => {
  return (
    <BookmarkWrap onClick={onClick} gap={gap}>
      {is_saved_shop ? <IconStarSolid color={saved_icon_color} /> : <IconStarRegular color={icon_color} />}
      <BookmarkCount variant='Caption_12_Multiline_Regular' as='span' color={count_color}>
        {numberInTenThousandWithFloor(bookmark_count)}
      </BookmarkCount>
    </BookmarkWrap>
  );
};

const BookmarkWrap = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48px;
  gap: ${({ gap }) => gap}px;
`;

const BookmarkCount = styled(Text)`
  line-height: 14.4px;
`;
